/** When your routing table is too long, you can split it into small modules**/

import Layout from "@/layout";
var screenRouter = [{
  path: "/",
  name: "workbenchscreen",
  component: Layout,
  children: [{
    path: "workbenchscreen",
    component: function component() {
      return import("@/views/gov/workbenchscreen");
    },
    meta: {
      title: "工作台",
      icon: "nav_workbench",
      roles: ["screen", "screen_03"]
    }
  }]
}, {
  path: "/",
  name: "screendatareport",
  component: Layout,
  meta: {
    title: "数据分析",
    icon: "nav_data",
    roles: ["screen", "screen_03", "district"]
  },
  children: [{
    path: "screenvision",
    component: function component() {
      return import("@/views/screen/data/screenvision");
    },
    meta: {
      title: "视力分析"
    }
  }, {
    path: "screenillness",
    component: function component() {
      return import("@/views/screen/data/screenillness");
    },
    meta: {
      title: "常见病分析"
    }
  }
  // {
  //   path: 'screeninspection',
  //   component: () => import('@/views/screen/data/screeninspection'),
  //   meta: { title: '行为影响因素监测', },
  // },
  ]
}, {
  path: "/screen/infor",
  name: "infor",
  component: Layout,
  hidden: true,
  meta: {
    title: "辖区数据",
    icon: "nav_functive",
    roles: ["screen"]
  },
  children: [{
    path: "information",
    component: function component() {
      return import("@/views/screen/infor/information");
    },
    meta: {
      title: "辖区数据总览",
      icon: "home"
    }
  }, {
    path: "informationschooldetail",
    component: function component() {
      return import("@/views/screen/infor/informationschooldetail");
    },
    meta: {
      title: "辖区数据详情",
      icon: "home"
    }
  }, {
    path: "informationscreendetail",
    component: function component() {
      return import("@/views/screen/infor/informationscreendetail");
    },
    meta: {
      title: "辖区数据详情",
      icon: "home"
    }
  }]
},
// 常见病监测
{
  path: "/screen/functionally",
  name: "functionallys",
  component: Layout,
  meta: {
    title: "常见病监测",
    icon: "nav_func",
    roles: ["screen", "screen_03"]
  },
  children: [{
    path: "screenplanmanage",
    component: function component() {
      return import("@/views/screen/functionally/manage/components/planmanage");
    },
    meta: {
      title: "筛查计划管理",
      roles: ["screen"]
    }
  }, {
    path: "screenplanmanage",
    component: function component() {
      return import("@/views/screen/survey/manage/planmanage");
    },
    meta: {
      title: "筛查计划管理",
      roles: ["screen_03"]
    }
  }, {
    path: "screenschoolmanage",
    component: function component() {
      return import("@/views/screen/functionally/manage/components/schoolmanage");
    },
    meta: {
      title: "学校/街道管理",
      roles: ["screen"]
    }
  }, {
    path: "screenschoolmanage",
    component: function component() {
      return import("@/views/screen/survey/manage/components/school");
    },
    meta: {
      title: "学校管理",
      roles: ["screen_03"]
    }
  }, {
    path: "plansetting",
    component: function component() {
      return import("@/views/screen/plansetting");
    },
    meta: {
      title: "筛查项目设置",
      roles: ["screen"]
    }
  }, {
    path: "screenchecksetting",
    component: function component() {
      return import("@/views/screen/survey/manage/components/checksetting");
    },
    meta: {
      title: "筛查项目设置",
      roles: ["screen_03"]
    }
  }, {
    path: "screenfilemanage",
    component: function component() {
      return import("@/views/screen/functionally/manage/components/filemanage");
    },
    meta: {
      title: "学生/居民档案管理",
      roles: ["screen"]
    }
  }, {
    path: "screenfilemanage",
    component: function component() {
      return import("@/views/screen/survey/manage/components/studentFile");
    },
    meta: {
      title: "档案管理",
      roles: ["screen_03"]
    }
  }, {
    path: "screenprogress",
    component: function component() {
      return import("@/views/screen/progress");
    },
    meta: {
      title: "筛查进度",
      roles: ["screen", "screen_03"]
    }
  }, {
    path: "screenassess",
    component: function component() {
      return import("@/views/screen/assessgx");
    },
    meta: {
      title: "质量控制",
      roles: ["screen", "screen_03"]
    }
  }, {
    path: "screenexport",
    component: function component() {
      return import("@/views/screen/manage/export");
    },
    meta: {
      title: "导出数据",
      roles: ["screen"]
    }
  }, {
    path: "screenexport",
    component: function component() {
      return import("@/views/screen/survey/manage/export");
    },
    meta: {
      title: "导出数据",
      roles: ["screen_03"]
    }
  }]
},
// 调查问卷
{
  path: "/screen/questionably",
  name: "questionably",
  component: Layout,
  meta: {
    title: "调查问卷",
    icon: "nav_ques",
    roles: ["screen", "screen_03"]
  },
  children: [{
    path: "questionnaire",
    component: function component() {
      return import("@/views/gov/questionnaire2");
    },
    meta: {
      title: "调查问卷",
      roles: ["screen", "screen_03"]
    }
  }]
},
// region 健康干预工作
{
  path: "/gov/healthily-work",
  name: "gydataanalysis",
  component: Layout,
  meta: {
    title: "健康干预工作",
    icon: "nav_sys",
    roles: ["screen"]
  },
  children: [{
    path: "gysetting",
    component: function component() {
      return import("@/views/gov/gywork/gySetting");
    },
    meta: {
      title: "健康干预工作设置"
    }
  }, {
    path: "gyfile",
    component: function component() {
      return import("@/views/gov/gywork/gyFile");
    },
    meta: {
      title: "健康干预档案管理"
    }
  }, {
    path: "gyinform",
    component: function component() {
      return import("@/views/gov/gywork/gyInform");
    },
    meta: {
      title: "AI预警通知设置"
    }
  },
  // {
  //   path: "gyanaly",
  //   component: () => import("@/views/gov/functionally/interfere/components/provinceAnalysis"),
  //   meta: { title: "健康干预效果分析" }
  // }
  {
    path: "sub",
    component: function component() {
      return import("@/views/gov/gywork/components/gySub");
    },
    hidden: true,
    meta: {
      title: "订阅相关"
    }
  }, {
    path: "inform",
    component: function component() {
      return import("@/views/gov/gywork/components/gyInform");
    },
    hidden: true,
    meta: {
      title: "推送与通知"
    }
  }, {
    path: "ques",
    component: function component() {
      return import("@/views/gov/gywork/components/gyQues");
    },
    hidden: true,
    meta: {
      title: "调查问卷"
    }
  }, {
    path: "sight",
    component: function component() {
      return import("@/views/gov/gywork/components/gySight");
    },
    hidden: true,
    meta: {
      title: "视力自测与监测"
    }
  }]
},
// endregion 健康干预工作

// 系统功能
{
  path: "/screen/systematically",
  name: "systematicallys",
  component: Layout,
  meta: {
    title: "系统功能",
    icon: "nav_sys",
    roles: ["screen", "screen_03"]
  },
  children: [{
    path: "screenmanage",
    component: function component() {
      return import("@/views/screen/functionally/manage");
    },
    meta: {
      title: "账号管理",
      roles: ["screen", "screen_03"]
    }
  }, {
    path: "screenrobot",
    component: function component() {
      return import("@/views/screen/robot");
    },
    meta: {
      title: "智能语料库",
      roles: ["screen"]
    }
  }, {
    path: "screencustomerservice",
    component: function component() {
      return import("@/views/screen/customerservice");
    },
    meta: {
      title: "患者咨询",
      roles: ["screen"]
    }
  }, {
    path: "screenmessage",
    component: function component() {
      return import("@/views/screen/notify");
    },
    meta: {
      title: "发送通知",
      roles: ["screen"]
    }
  }, {
    path: "operationlog",
    component: function component() {
      return import("@/views/gov/operationlog");
    },
    meta: {
      title: "操作日志",
      roles: ["screen"]
    }
  }, {
    path: "helpcenter",
    component: function component() {
      return import("@/views/screen/helpcenter");
    },
    meta: {
      title: "帮助中心",
      roles: ["screen"]
    }
  }]
},
// 功能分类修改前
// {
//   path: "/screen/functionally",
//   name: "functionallys",
//   component: Layout,
//   meta: { title: "常用功能", icon: "nav_functive", roles: ["screen", "screen_03"] },
//   children: [
//     {
//       path: "screenmanage",
//       component: () => import("@/views/screen/functionally/manage"),
//       meta: { title: "账号管理", roles: ["screen", "screen_03"] }
//     },
//     {
//       path: "plansetting",
//       component: () => import("@/views/screen/plansetting"),
//       meta: { title: "筛查项目设置", roles: ["screen"] }
//     },
//     {
//       path: "screenchecksetting",
//       component: () => import("@/views/screen/survey/manage/components/checksetting"),
//       meta: { title: "筛查项目设置", roles: ["screen_03"] }
//     },
//     {
//       path: "screenplanmanage",
//       component: () => import("@/views/screen/functionally/manage/components/planmanage"),
//       meta: { title: "筛查计划管理", roles: ["screen"] }
//     },
//     {
//       path: "screenplanmanage",
//       component: () => import("@/views/screen/survey/manage/planmanage"),
//       meta: { title: "筛查计划管理", roles: ["screen_03"] }
//     },
//     {
//       path: "screenschoolmanage",
//       component: () => import("@/views/screen/functionally/manage/components/schoolmanage"),
//       meta: { title: "学校/街道管理", roles: ["screen"] }
//     },
//     {
//       path: "screenschoolmanage",
//       component: () => import("@/views/screen/survey/manage/components/school"),
//       meta: { title: "学校管理", roles: ["screen_03"] }
//     },
//     {
//       path: "screenfilemanage",
//       component: () => import("@/views/screen/functionally/manage/components/filemanage"),
//       meta: { title: "档案管理", roles: ["screen"] }
//     },
//     {
//       path: "screenfilemanage",
//       component: () => import("@/views/screen/survey/manage/components/studentFile"),
//       meta: { title: "档案管理", roles: ["screen_03"] }
//     },
//     {
//       path: "screenprogress",
//       component: () => import("@/views/screen/progress"),
//       meta: { title: "筛查进度", roles: ["screen", "screen_03"] }
//     },
//     {
//       path: "screenassess",
//       component: () => import("@/views/screen/assessgx"),
//       meta: { title: "质量控制", roles: ["screen", "screen_03"] }
//     },
//     {
//       path: "contrast",
//       component: () => import("@/views/gov/contrast"),
//       meta: {
//         title: "抽样对比",
//         roles: ["province", "city", "district", "screen", "screen_03"]
//       }
//     },
//     // {
//     //   path: 'screenassessschool',
//     //   hidden: true,
//     //   component: () => import('@/views/screen/assessschool'),
//     //   meta: { title: '质量控制',roles: ['screen'] }
//     // },
//     {
//       path: "screenexport",
//       component: () => import("@/views/screen/manage/export"),
//       meta: { title: "导出数据", roles: ["screen"] }
//     },
//     {
//       path: "screenexport",
//       component: () => import("@/views/screen/survey/manage/export"),
//       meta: { title: "导出数据", roles: ["screen_03"] }
//     },
//     {
//       path: "screencustomerservice",
//       component: () => import("@/views/screen/customerservice"),
//       meta: { title: "患者咨询", roles: ["screen"] }
//     },
//     {
//       path: "screenrobot",
//       component: () => import("@/views/screen/robot"),
//       meta: { title: "智能语料库", roles: ["screen"] }
//     },
//     {
//       path: "screenmessage",
//       component: () => import("@/views/screen/notify"),
//       meta: { title: "消息中心", roles: ["screen"] }
//     },
//     {
//       path: "operationlog",
//       component: () => import("@/views/gov/operationlog"),
//       meta: { title: "操作日志", roles: ["screen"] }
//     },
//     // {
//     //   path: "datadeploy",
//     //   component: () => import("@/views/screen/datadeploy/manage"),
//     //   meta: { title: "数据报告配置", roles: ["screen"] }
//     // },
//     {
//       path: "helpcenter",
//       component: () => import("@/views/screen/helpcenter"),
//       meta: { title: "帮助中心", roles: ["screen"] }
//     },
//     // {
//     //   path: 'robot',
//     //   component: () => import('@/views/screen/robot'),
//     //   meta: { title: '操作日志',roles: ['screen'] }
//     // },
//     // {
//     //   path: 'set',
//     //   component: () => import('@/views/gov/set'),
//     //   meta: { title: '检查项目设置',icon: 'ope',roles: ['province', 'city', 'district', 'superadmin'] }
//     // },
//   ]
// },

// 校级
{
  path: '/screen/progress/progressschool',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'screen/progress/progressschool',
    hidden: true,
    component: function component() {
      return import('@/views/screen/progressschool');
    },
    meta: {
      title: '筛查进度',
      icon: 'progress',
      roles: ['screen']
    }
  }]
}, {
  path: "/screen/account",
  name: "screenaccount",
  component: Layout,
  hidden: true,
  meta: {
    title: "机构管理",
    icon: "account",
    roles: ["screen"]
  },
  children: [
  // {
  //   path: 'screen',
  //   component: () => import('@/views/screen/account/screen'),
  //   meta: { title: '筛查机构账号分配' }
  // },
  {
    path: "screener",
    component: function component() {
      return import("@/views/screen/account/screener");
    },
    meta: {
      title: "筛查员账号管理"
    }
  }, {
    path: "school",
    component: function component() {
      return import("@/views/screen/account/schoolaccount");
    },
    meta: {
      title: "学校账号管理"
    }
  }, {
    path: "subaccount",
    component: function component() {
      return import("@/views/screen/account/subaccount");
    },
    meta: {
      title: "子账号分配",
      roles: ["screen"]
    }
  }]
}, {
  path: "/screen/manage",
  name: "manage",
  hidden: true,
  component: Layout,
  meta: {
    title: "筛查管理",
    icon: "ope",
    roles: ["screen"]
  },
  children: [{
    path: "school",
    component: function component() {
      return import("@/views/screen/manage/school");
    },
    meta: {
      title: "学校管理"
    }
  }, {
    path: "school",
    component: function component() {
      return import("@/views/screen/account/schoolaccount");
    },
    meta: {
      title: "学校账号管理",
      roles: ["district"]
    }
  }, {
    path: "plan",
    component: function component() {
      return import("@/views/screen/manage/plan");
    },
    meta: {
      title: "筛查计划管理"
    }
  }, {
    path: "export",
    component: function component() {
      return import("@/views/screen/manage/export");
    },
    meta: {
      title: "下载文件"
    }
  }, {
    path: "sendmsg",
    component: function component() {
      return import("@/views/screen/manage/sendmsg");
    },
    meta: {
      title: "发送通知"
    }
  }, {
    path: "assess",
    component: function component() {
      return import("@/views/screen/assess");
    },
    meta: {
      title: "质量控制"
    }
  }, {
    path: "planmanage",
    component: function component() {
      return import("@/views/screen/functionally/manage/components/components/plan");
    },
    meta: {
      title: "计划管理"
    }
  }, {
    path: "schoolmanage",
    component: function component() {
      return import("@/views/screen/functionally/manage/components/components/school");
    },
    meta: {
      title: "学校管理"
    }
  }, {
    path: "streetmanage",
    component: function component() {
      return import("@/views/screen/functionally/manage/components/components/street");
    },
    meta: {
      title: "街道管理"
    }
  }, {
    path: "studentmanage",
    component: function component() {
      return import("@/views/screen/functionally/manage/components/components/studentFile");
    },
    meta: {
      title: "学生档案管理"
    }
  }, {
    path: "personmanage",
    component: function component() {
      return import("@/views/screen/functionally/manage/components/components/personFile");
    },
    meta: {
      title: "居民档案管理"
    }
  }]
}, {
  path: "/screen/setting",
  component: Layout,
  hidden: true,
  children: [{
    path: "areasetting",
    name: "areasetting",
    component: function component() {
      return import("@/views/screen/areasetting");
    },
    meta: {
      title: "筛查项目配置",
      roles: ["screen"]
    }
  }, {
    path: "checksetting",
    name: "checksetting",
    component: function component() {
      return import("@/views/screen/checksetting");
    },
    meta: {
      title: "筛查项目配置",
      roles: ["screen"]
    }
  }]
}, {
  path: "/screen/progress",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "progress",
    component: function component() {
      return import("@/views/screen/progress");
    },
    meta: {
      title: "筛查进度",
      icon: "progress",
      roles: ["screen"]
    }
  }]
}, {
  path: "/screen/roport",
  name: "roport",
  hidden: true,
  component: Layout,
  meta: {
    title: "筛查数据分析",
    icon: "report",
    roles: ["screen"]
  },
  children: [{
    path: "year",
    component: function component() {
      return import("@/views/screen/report/year");
    },
    meta: {
      title: "年度数据分析"
    }
  }, {
    path: "school",
    component: function component() {
      return import("@/views/screen/report/school");
    },
    meta: {
      title: "学校数据分析"
    }
  }, {
    path: "grade",
    component: function component() {
      return import("@/views/screen/report/grade");
    },
    meta: {
      title: "年级数据分析"
    }
  }, {
    path: "class",
    component: function component() {
      return import("@/views/screen/report/class");
    },
    meta: {
      title: "班级数据分析"
    }
  }, {
    path: "personal",
    component: function component() {
      return import("@/views/gov/personal");
    },
    meta: {
      title: "个案数据分析"
    }
  }]
}, {
  path: "/screentotal",
  component: Layout,
  hidden: true,
  meta: {
    roles: ["screen"]
  },
  children: [{
    path: "",
    name: "screentotal",
    component: function component() {
      return import("@/views/gov/report/workbenchscreentotal");
    },
    meta: {
      title: "数据总览",
      roles: ["screen"]
    }
  }]
}, {
  path: "/screen/notify",
  component: Layout,
  hidden: true,
  meta: {
    roles: ["screen"]
  },
  children: [{
    path: "",
    name: "notify",
    component: function component() {
      return import("@/views/screen/notify");
    },
    meta: {
      title: "重要通知",
      icon: "notify"
    }
  }]
}, {
  path: "/screen/operationlog",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "operationlog",
    component: function component() {
      return import("@/views/gov/operationlog");
    },
    meta: {
      title: "操作日志",
      icon: "operationlog",
      roles: ["screen"]
    }
  }]
}, {
  path: "/screen/mytask",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "mytask",
    hidden: true,
    component: function component() {
      return import("@/views/screen/mytask");
    },
    meta: {
      title: "我的任务",
      icon: "notify",
      roles: ["screen"]
    }
  }]
}, {
  path: "/screen/warning",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "warning",
    hidden: true,
    component: function component() {
      return import("@/views/screen/warning");
    },
    meta: {
      title: "预警人数",
      icon: "notify",
      roles: ["screen"]
    }
  }]
}, {
  path: "/screen/classes",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "classes",
    hidden: true,
    component: function component() {
      return import("@/views/screen/classes");
    },
    meta: {
      title: "戴镜人数",
      icon: "notify",
      roles: ["screen"]
    }
  }]
}, {
  path: "/screen/robot",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "robot",
    component: function component() {
      return import("@/views/screen/robot");
    },
    meta: {
      title: "智能语料库",
      icon: "robot",
      roles: ["screen"]
    }
  }]
}, {
  path: "/screen/customerservice",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "robocustomerservicet",
    component: function component() {
      return import("@/views/screen/customerservice");
    },
    meta: {
      title: "患者咨询",
      icon: "customer-service",
      roles: ["screen"]
    }
  }]
}];
export default screenRouter;